

<body class="mat-app-background ">
  <div class="mat-elevation-z8 ccorbit-mat-table col-panel-wrapper" [cdkContextMenuTriggerFor]="context_menu">
    <div class="floating-col-panel" (mouseleave)="contraerColPanel()"
         [ngClass]="{'expanded': colPanelOpen}">
      <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
        <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
      </div>
      <div class="col-panel-content">
        <h6 class="col-panel-title mb-2">Columnas</h6>
        <ng-container *ngIf="!modelo">
          <div class="col-panel-option" *ngFor="let column of tableColumns">
            <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id)" [color]="'primary'">{{column.name}}</mat-checkbox>
          </div>
        </ng-container>
        <ng-container *ngIf="modelo">
          <div class="col-panel-option" *ngFor="let column of tableColumns">
            <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility2(column.id)" [color]="'primary'">{{column.name}}</mat-checkbox>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="compact-checkboxes" aria-hidden="false">
      <ng-container *ngIf="modelo">
        <button mat-icon-button class="compact-icon" [class.active]="isProcPla" (click)="isProcPla = !isProcPla; filterData()" matTooltip="Procesados">
          <mat-icon>done</mat-icon>
        </button>
        <button mat-icon-button class="compact-icon" [class.active]="isACtualPla" (click)="isACtualPla = !isACtualPla; filterData()" matTooltip="Actualizacion">
          <mat-icon>autorenew</mat-icon>
        </button>
      </ng-container>
      <ng-container *ngIf="isPlanificador">
        <button mat-icon-button class="compact-icon" [class.active]="isProcDiv" (click)="isProcDiv = !isProcDiv; filterData()" matTooltip="Procesados">
          <mat-icon>done</mat-icon>
        </button>
        <button mat-icon-button class="compact-icon" [class.active]="isACtualDiv" (click)="isACtualDiv = !isACtualDiv; filterData()" matTooltip="Actualizacion">
          <mat-icon>autorenew</mat-icon>
        </button>
      </ng-container>

      <ng-container *ngIf="isGestion">
        <button mat-icon-button class="compact-icon" [class.active]="isProcGest" (click)="isProcGest = !isProcGest; filterData()" matTooltip="Procesados">
          <mat-icon>done</mat-icon>
        </button>
        <button mat-icon-button class="compact-icon" [class.active]="isACtualGest" (click)="isACtualGest = !isACtualGest; filterData()" matTooltip="Actualizacion">
          <mat-icon>autorenew</mat-icon>
        </button>
      </ng-container>
      <ng-container *ngIf="isBroker">
        <button mat-icon-button class="compact-icon" [class.active]="isProcBrok" (click)="isProcBrok = !isProcBrok; filterData()" matTooltip="Procesados">
          <mat-icon>done</mat-icon>
        </button>
        <button mat-icon-button class="compact-icon" [class.active]="isACtualBrok" (click)="isACtualBrok = !isACtualBrok; filterData()" matTooltip="Actualizacion">
          <mat-icon>autorenew</mat-icon>
        </button>
      </ng-container>
    </div>

    <div class="scroll-date" *ngIf="currentDate">{{ currentDate | smartDate }}</div>
    
    <cdk-virtual-scroll-viewport #viewportGestion id="viewportGestion" item [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34" [bufferMultiplier]="0.35" class="wrapper mat-elevation-z2 tableStyle" *ngIf="modelo" (scrolledIndexChange)="mostrarFechaScroll($event)">
      <table cdk-table recycleRows [dataSource]="opedata" class="table-striped tableStyle" >

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsPl; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsPl;" (click)="selectRow(row)"
          [ngClass]="{'selected': row === filaSeleccionada}" (contextmenu)="mostrarMenu($event, row)"></tr>
        <ng-container *ngFor="let tablecol of tableColumnsPl">

          <ng-container [cdkColumnDef]="tablecol.id">
            <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
              {{tablecol.name}}
            </th>
            <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA ↑' || item[tablecol.id] === 'SALIDA ↓',
                                                                'entrada': item[tablecol.id] === 'ENTRADA ↑' || item[tablecol.id] === 'ENTRADA ↓',
                                                                'numero-positivo': item[tablecol.id] > 0,
                                                                'numero-negativo': item[tablecol.id] < 0
                                                                }">
              <ng-container *ngIf="tablecol.isString">
                {{item[tablecol.id]}}   <ng-container *ngIf="tablecol.id === 'nombreCompania'">
                  {{item['secType'] === 'CFD' ? ' CFD' : ''}}
                </ng-container>
              </ng-container>
             
              <ng-container *ngIf="tablecol.isDate">
                {{item[tablecol.id] | smartDate }}
              </ng-container>
              <ng-container *ngIf="tablecol.isNumber">
                {{item[tablecol.id] | number:((tablecol.id === 'precioentradareal' || tablecol.id === 'preciosalidareal' || tablecol.id === 'stoplossinicial' || tablecol.id === 'profit') && item['secType'] === 'CFD' ? '1.5-5' : '1.2-2')}}
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
      </table>
    </cdk-virtual-scroll-viewport>
    <cdk-virtual-scroll-viewport #viewportGestionDiv id="viewportGestionDiv" item [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34" [bufferMultiplier]="0.35" class="wrapper mat-elevation-z2 tableStyle" *ngIf="isPlanificador" (scrolledIndexChange)="mostrarFechaScroll($event)">
      <table cdk-table recycleRows [dataSource]="divOpeData" class="table-striped tableStyle">

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
          [ngClass]="{'selected': row === filaSeleccionada}" (contextmenu)="mostrarMenu($event, row)"></tr>
        <ng-container *ngFor="let tablecol of tableColumns">

          <ng-container [cdkColumnDef]="tablecol.id">
            <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
              {{tablecol.name}}
            </th>
            <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA ↑' || item[tablecol.id] === 'SALIDA ↓',
                                                                'entrada': item[tablecol.id] === 'ENTRADA ↑' || item[tablecol.id] === 'ENTRADA ↓',
                                                                'numero-positivo': item[tablecol.id] > 0,
                                                                'numero-negativo': item[tablecol.id] < 0
                                                                }">
              <ng-container *ngIf="tablecol.isString">
                {{item[tablecol.id]}}<ng-container *ngIf="tablecol.id === 'nombreCompania'">
                  {{item['secType'] === 'CFD' ? ' CFD' : ''}}
                </ng-container>
              </ng-container>
              <ng-container *ngIf="tablecol.isDate">
                {{item[tablecol.id] | smartDate }}
              </ng-container>
              <ng-container *ngIf="tablecol.isNumber">
                  {{item[tablecol.id] | number:((tablecol.id === 'precioentradareal' || tablecol.id === 'preciosalidareal' || tablecol.id === 'stoplossinicial' || tablecol.id === 'profit') && item['secType'] === 'CFD' ? '1.5-5' : '1.2-2')}}
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
      </table>
    </cdk-virtual-scroll-viewport>
    <!--     //----------------------------TABLA DE GESTOR--------------------- -->

    <cdk-virtual-scroll-viewport #viewportGestionGest id="viewportGestionGest" item [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34" [bufferMultiplier]="0.35" class="wrapper mat-elevation-z2 tableStyle" *ngIf="isGestion" (scrolledIndexChange)="mostrarFechaScroll($event)">
      <table cdk-table recycleRows [dataSource]="gestOpeData" class="table-striped tableStyle">

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
          [ngClass]="{'selected': row === filaSeleccionada}" (contextmenu)="mostrarMenu($event, row)"></tr>
        <ng-container *ngFor="let tablecol of tableColumns">

          <ng-container [cdkColumnDef]="tablecol.id">
            <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
              {{tablecol.name}}
            </th>
            <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA ↑' || item[tablecol.id] === 'SALIDA ↓',
                                                            'entrada': item[tablecol.id] === 'ENTRADA ↑' || item[tablecol.id] === 'ENTRADA ↓',
                                                          'numero-positivo': item[tablecol.id] > 0,
                                                          'numero-negativo': item[tablecol.id] < 0
                                                          }">
              <ng-container *ngIf="tablecol.isString">
                {{item[tablecol.id]}}<ng-container *ngIf="tablecol.id === 'nombreCompania'">
                  {{item['secType'] === 'CFD' ? ' CFD' : ''}}
                </ng-container>
              </ng-container>
              <ng-container *ngIf="tablecol.isDate">
                {{item[tablecol.id] | smartDate }}
              </ng-container>
              <ng-container *ngIf="tablecol.isNumber">
                {{item[tablecol.id] | number:((tablecol.id === 'precioentradareal' || tablecol.id === 'preciosalidareal' || tablecol.id === 'stoplossinicial' || tablecol.id === 'profit') && item['secType'] === 'CFD' ? '1.5-5' : '1.2-2')}}
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
      </table>
    </cdk-virtual-scroll-viewport>

    <!-- ------------------------------ BROKER-------------------------- -->
    <cdk-virtual-scroll-viewport #viewportGestionBrok id="viewportGestionBrok" item [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34" [bufferMultiplier]="0.35" class="wrapper2 mat-elevation-z2 tableStyle" *ngIf="isBroker" (scrolledIndexChange)="mostrarFechaScroll($event)">
      <table cdk-table recycleRows [dataSource]="brokOpeData" class="table-striped tableStyle">

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
          [ngClass]="{'selected': row === filaSeleccionada}" (contextmenu)="mostrarMenu($event, row)"></tr>
        <ng-container *ngFor="let tablecol of tableColumns">

          <ng-container [cdkColumnDef]="tablecol.id">
            <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
              {{tablecol.name}}
            </th>
            <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA ↑' || item[tablecol.id] === 'SALIDA ↓',
                                                                'entrada': item[tablecol.id] === 'ENTRADA ↑' || item[tablecol.id] === 'ENTRADA ↓',
                                                        'numero-positivo': item[tablecol.id] > 0,
                                                        'numero-negativo': item[tablecol.id] < 0
                                                        }">
              <ng-container *ngIf="tablecol.isString">
                {{item[tablecol.id]}}<ng-container *ngIf="tablecol.id === 'nombreCompania'">
                  {{item['secType'] === 'CFD' ? ' CFD' : ''}}
                </ng-container>
              </ng-container>
              <ng-container *ngIf="tablecol.isDate">
                {{item[tablecol.id] | smartDate }}
              </ng-container>
              <ng-container *ngIf="tablecol.isNumber">
                {{item[tablecol.id] | number:((tablecol.id === 'precioentradareal' || tablecol.id === 'preciosalidareal' || tablecol.id === 'stoplossinicial' || tablecol.id === 'profit') && item['secType'] === 'CFD' ? '1.5-5' : '1.2-2')}}
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
      </table>
    </cdk-virtual-scroll-viewport>

  </div>
  <div class="spinner-container" *ngIf="loading">
    <mat-spinner diameter="100"></mat-spinner>
  </div>


  <ng-template #context_menu let-data="data">
    <div class="example-menu" cdkMenu [ngClass]="{'dark-theme': isDark, 'light-theme': !isDark}">
      <button class="example-menu-item" (click)="verGrafica()" cdkMenuItem>
        <mat-icon class="menu-icon">insert_chart</mat-icon>
        <span>Ver Gráfica</span>
      </button>
      <button class="example-menu-item" (click)="verModelo()" cdkMenuItem>
        <mat-icon class="menu-icon">open_in_new</mat-icon>
        <span>Ver Modelo</span>
      </button>
      <button class="example-menu-item" *ngIf="isGestion" (click)="dialogEliminar(false)" cdkMenuItem>
        <mat-icon class="menu-icon">delete</mat-icon>
        <span>Eliminar Operacion</span>
      </button>
      <button class="example-menu-item" *ngIf="isBroker" (click)="dialogEliminar(true)"
        cdkMenuItem>
        <mat-icon class="menu-icon">delete</mat-icon>
        <span>Eliminar Operacion</span>
      </button>
    </div>
  </ng-template>


  <script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.11.8/dist/umd/popper.min.js"
    integrity="sha384-I7E8VVD/ismYTF4hNIPjVp/Zjvgyol6VFvRkX/vR+Vc4jQkC+hVqc2pM8ODewa9r"
    crossorigin="anonymous"></script>
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.min.js"
    integrity="sha384-0pUGZvbkm6XF6gxjEnlmuGrJXVbNuzT9qBBavbLwCsOGabYfZo0T0to5eqruptLy"
    crossorigin="anonymous"></script>
</body>

<!--   </mat-drawer-container> -->
